import { Reducer } from 'redux';
import { INVITE_ROOM_ADD, INVITE_ROOM_REMOVE } from './actions';

// How long an invite keeps a room joinable from the game list (matches InviteDialog countdown).
export const INVITE_TTL_MS = 30000;

// A room the user has been invited to, joinable from the game list until expiresAt.
// Tracked independently of `invites` so it survives the InviteDialog being denied/dismissed.
export interface InviteRoom {
  roomId: number;
  expiresAt: number;
}

const initialState: InviteRoom[] = [];

export const addInviteRoom = (roomId: number, expiresAt: number) => ({
  type: INVITE_ROOM_ADD,
  payload: { roomId, expiresAt }
});

export const removeInviteRoom = (roomId: number) => ({ type: INVITE_ROOM_REMOVE, payload: roomId });

const inviteRoomsReducer: Reducer<InviteRoom[]> = (state = initialState, action): InviteRoom[] => {
  if (action.type === INVITE_ROOM_ADD) {
    const { roomId, expiresAt } = action.payload as InviteRoom;
    // replace any existing entry for the same room (resets the timer)
    return state.filter((r) => r.roomId !== roomId).concat({ roomId, expiresAt });
  } else if (action.type === INVITE_ROOM_REMOVE) {
    return state.filter((r) => r.roomId !== action.payload);
  }
  return state;
};

export default inviteRoomsReducer;
